import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Buefy from 'buefy';
import 'buefy/dist/buefy.css'
import axios from 'axios'
import './registerServiceWorker'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bulma-extensions/dist/css/bulma-extensions.min.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import VeeValidate from 'vee-validate'
import "./filters/filter"

Vue.use(Buefy)
Vue.use(VeeValidate)

Vue.config.productionTip = false
// cloud
axios.defaults.baseURL = "https://api-payroll.anynetworksystems.com/"

// axios.defaults.baseURL = "https://localhost:44317/"
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')